export const siteSettings = {
  name: "Live Market Pro",
  link: "https://livemarketpros.com",
  email: "support@livemarketpros.com",
  appLink: "https://app.livemarketpros.com",
};
